module.exports = __webpack_public_path__ + "img/p3.d4bbccfb.png";